export interface ReportType {
	Name:string;
	ReportUri:string;
	Format:ReportFormat[],
	BodyParameters?:Parameter[],
	QueryStringParameters?:Parameter[]
}

export interface ReportFormat {
	DisplayName:string;
	PropertyName:string;
	Type:ParamType;
}

export interface Parameter {
	Required:boolean;
	PropertyName:string;
	DisplayName:string;
	Type:ParamType;
}

export enum ParamType {
	string = 'System.String',
	strings = 'String[]',
	boolean = 'Boolean',
	date = 'System.DateTime',
	number = 'Long',
	numbers = 'Long[]'
}



// WEBPACK FOOTER //
// ./src/phoenix/domain/report-type.ts